/*
 * news.js - infinite scroll for the news listing (spec 11).
 *
 * Progressive enhancement only: page 1 is server-rendered, and the same content is always
 * reachable at the crawlable /news?page=n URLs (plus rel=next in <head> and every article in
 * sitemap.xml). With JavaScript off, the <noscript> "More news" link does the same job.
 *
 * Cards are appended below the existing grid and .news-thumb carries an aspect-ratio in
 * acquaint.css, so nothing already on screen moves - CLS stays at zero (spec 22).
 */

const grid = document.getElementById('news-grid');

if (grid && 'IntersectionObserver' in window) {
  let nextPage = Number.parseInt(grid.dataset.nextPage ?? '0', 10);
  let loading = false;

  if (nextPage > 0) {
    // A zero-height sentinel after the grid; it reserves no space, so it cannot shift layout.
    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.height = '1px';
    grid.after(sentinel);

    const stop = (observer) => {
      observer.disconnect();
      sentinel.remove();
    };

    const loadNext = async (observer) => {
      if (loading || nextPage <= 0) {
        return;
      }

      loading = true;
      try {
        const response = await fetch(`/news/page/${nextPage}`, {
          headers: { 'X-Requested-With': 'fetch' },
        });

        if (response.status === 204 || !response.ok) {
          nextPage = 0;
          stop(observer);
          return;
        }

        const html = (await response.text()).trim();
        if (!html) {
          nextPage = 0;
          stop(observer);
          return;
        }

        grid.insertAdjacentHTML('beforeend', html);
        nextPage += 1;
      } catch {
        // Network trouble: stop enhancing and leave the crawlable pager as the way forward.
        nextPage = 0;
        stop(observer);
      } finally {
        loading = false;
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            void loadNext(observer);
          }
        }
      },
      { rootMargin: '400px 0px' },
    );

    observer.observe(sentinel);
  }
}
